import { useTheme as useMuiTheme } from '@mui/material'
import { theme as defaultThemeConfig, type ThemeConfig } from '../core/App/theme'

function useTheme(): ThemeConfig {
	const muiTheme = useMuiTheme()
	// MUI's useTheme returns an empty object ({}) when outside a ThemeProvider.
	// Fall back to the static theme config in that case.
	if (muiTheme && 'palette' in muiTheme) {
		return muiTheme as unknown as ThemeConfig
	}
	return defaultThemeConfig as ThemeConfig
}

export default useTheme
